// tslint:disable:trailing-comma
import { ShipmentLocationTypeIdType } from '../common';

export interface ProductsByColorReq {
  salesDocumentTypeId: number;
  productColorId?: number;
  productLineId: number | string;
  shipmentLocation: {
    shipmentLocationId: number
    shipmentLocationType: ShipmentLocationTypeIdType
  };
  shipmentLocationId?: string;
  plantId?: number;
}
